module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-container"
  }, [_c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_c('div', {
    staticClass: "tools"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/ejklogo_01.png")
    }
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v("您好~ " + _vm._s(_vm.collapsed ? "" : _vm.user))]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/tuichuleft.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "el-dropdown-link userinfo-inner",
    on: {
      "click": _vm.logoutFun
    }
  }, [_vm._v("退出")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logoutFun($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    ref: "menu",
    staticClass: "el-menu-vertical-demo",
    staticStyle: {
      "background": "#eeeeef"
    },
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "active-text-color": "#ffd04b",
      "router": ""
    }
  }, [_c('el-submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClient),
      expression: "isClient"
    }],
    attrs: {
      "index": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {}), _vm._v(" "), _c('span', [_vm._v("开户数据表")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/menu1"
    }
  }, [_vm._v("推荐开户数")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/menu2"
    }
  }, [_vm._v("推荐开户明细")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/menu3"
    }
  }, [_vm._v("推荐关系明细表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/filiale1"
    }
  }, [_vm._v("分公司开户进度明细表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/filiale2"
    }
  }, [_vm._v("分公司开户进度表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/rank1"
    }
  }, [_vm._v("中支排名表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/rank2"
    }
  }, [_vm._v("营服排名表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/rank3"
    }
  }, [_vm._v("个人排名表")])], 2), _vm._v(" "), _c('el-submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClient),
      expression: "isClient"
    }],
    attrs: {
      "index": "4"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("客户数据表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/client1"
    }
  }, [_vm._v("客户全量数据表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/client2"
    }
  }, [_vm._v("关注注册开户分析表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/client3"
    }
  }, [_vm._v("点击量汇总表")])], 1), _vm._v(" "), _c('el-submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClient),
      expression: "isClient"
    }],
    attrs: {
      "index": "5"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("员工数据表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/indoor1"
    }
  }, [_vm._v("员工全量数据表")])], 1), _vm._v(" "), _c('el-submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClient),
      expression: "isClient"
    }],
    attrs: {
      "index": "6"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("积分管理")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/organization1"
    }
  }, [_vm._v("机构负责人金蟾豆列表")])], 1), _vm._v(" "), _c('el-submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClient),
      expression: "isClient"
    }],
    attrs: {
      "index": "7"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("每日数据表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/everydayData1"
    }
  }, [_vm._v("每日注册数据表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/everydayData2"
    }
  }, [_vm._v("每日推荐明细数据表")])], 1), _vm._v(" "), _c('el-submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClient),
      expression: "isClient"
    }],
    attrs: {
      "index": "8"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("贷款数据表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/loans1"
    }
  }, [_vm._v("贷款分析表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/loans2"
    }
  }, [_vm._v("逾期日报")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/loans4"
    }
  }, [_vm._v("贷款放款信息表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/loans6"
    }
  }, [_vm._v("保单贷授信申请表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/loans7"
    }
  }, [_vm._v("保单贷授信结果表")])], 1), _vm._v(" "), _c('el-submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClient),
      expression: "isClient"
    }],
    attrs: {
      "index": "9"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("存款数据表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/depositList13"
    }
  }, [_vm._v("存款分级明细表有效数据")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/depositList14"
    }
  }, [_vm._v("存款分级分公司")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/depositList15"
    }
  }, [_vm._v("存款分级中支")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/depositList16"
    }
  }, [_vm._v("存款分级营服")])], 1), _vm._v(" "), _c('el-submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isVip),
      expression: "isVip"
    }],
    attrs: {
      "index": "10"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("VIP专区")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/venusZone1"
    }
  }, [_vm._v("申请信息")])], 1), _vm._v(" "), _c('el-submenu', {
    attrs: {
      "index": "11"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("各机构数据")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/filialePower1"
    }
  }, [_vm._v("二级单位数据表")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/filialePower2"
    }
  }, [_vm._v("三级单位数据表")])], 1), _vm._v(" "), _c('el-submenu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClient),
      expression: "isClient"
    }],
    attrs: {
      "index": "12"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("数据上传")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/message1"
    }
  }, [_vm._v("数据上传")]), _vm._v(" "), (_vm.userTag == 'A') ? _c('el-menu-item', {
    attrs: {
      "index": "/message2"
    }
  }, [_vm._v("订单查询")]) : _vm._e(), _vm._v(" "), (_vm.userTag == 'A') ? _c('el-menu-item', {
    attrs: {
      "index": "/message3"
    }
  }, [_vm._v("合同查询")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": ""
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-718d4c5c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 3237
// module chunks = 1